import ToggleClass from "./helpers/toggleClass";
import HomePage from "./modules/homepage";
import Dialogs from "./modules/dialogs";
import Forms from "./modules/forms";
import Filters from "./modules/filters";
import Scroll from "./modules/scroll";
import Counter from "./modules/couter";
import Mobile from "./modules/mobile";
import Gus from "./modules/gus";
import Cookies from "./modules/cookies";
import Reload from "./modules/reload";
import Client from "./modules/client";

// PERSONALIZATOR
import init from './modules/personalizator/init';
import slider from './modules/personalizator/slider';
import loadParams from './modules/personalizator/loadParams';
import tabs from './modules/personalizator/tabs';
import variants from './modules/personalizator/variants';
import items from './modules/personalizator/items';
import pickFile from './modules/personalizator/pickFile';

/**
 * EVENTS
 */
import colorPicker from './modules/personalizator/events/colorPicker';
import preview from './modules/personalizator/events/preview';
import buy from './modules/personalizator/events/buy';
import attach from './modules/personalizator/events/attach';

